module.exports = __webpack_public_path__ + "img/skala-1855.87ab7c3b.png";